import { render, staticRenderFns } from "./LoginMain.vue?vue&type=template&id=261fe3c6&scoped=true"
import script from "./LoginMain.vue?vue&type=script&lang=js"
export * from "./LoginMain.vue?vue&type=script&lang=js"
import style0 from "./LoginMain.vue?vue&type=style&index=0&id=261fe3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261fe3c6",
  null
  
)

export default component.exports